import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../../components/digital-media/layout';
import { Container, makeStyles, Grid } from '@material-ui/core';
import { Link } from 'gatsby';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingTop: '130px',
    [theme.breakpoints.up('md')]: {
      paddingTop: '96px',
    },
    borderBottom: '1px solid #e1e1e1',
  },
  slotholder: {
    backgroundImage: `url('/img/digital-media/t_archive.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    width: '100%',
    height: '120px',
    [theme.breakpoints.up('md')]: {
      height: '200px',
    },
  },
  caption: {
    textAlign: 'center',
    color: 'white',
    fontSize: '30px',
    [theme.breakpoints.up('md')]: {
      fontSize: '48px',
      paddingTop: '65px',
      padingLeft: '90px',
    },
    paddingTop: '50px',
    paddingLeft: '80px',
  },
  captionEng: {
    textAlign: 'center',
    color: 'white',
    fontSize: '15px',
    [theme.breakpoints.up('md')]: {
      fontSize: '20px',
      paddingLeft: '270px',
    },
    paddingLeft: '150px',
    fontWeight: '200',
  },
  section1: {
    backgroundImage: `url('/img/digital-media/1231.png')`,
    backgroundRepeat: 'repeat-x',
    backgroundAttachment: 'scroll',
    backgroundPosition: 'top center',
    textAlign: 'center',
    fontsize: '16px',
    color: '#727272',
    paddingTop: '50px',
    paddingBottom: '50px',
  },
  section2: {
    paddingTop: '70px',
    borderBottom: '1px solid #e1e1e1',
    marginLeft: '20px',
    marginRight: '20px',
  },
  hr: {
    lineHeight: '25px',
    borderColor: '#dddddd',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    position: 'relative',
    margintTop: '15px',
    marginBottom: '30px',
  },
  contents: {
    color: '#666666',
    fontSize: '14px',
    margin: '11.9px 0px',
    lineHeight: '1.65em',
    textAlign: 'left',
  },
  icon: {
    paddingTop: '30px',
  },
  downloadArea: {
    marginTop: '50px',
    marginBottom: '100px',
  },
  download: {
    textDecoration: 'none',
    color: '#00AAFF',
    fontSize: '13px',
  },
}));

export default function ArchiveSystem() {
  const classes = useStyles();
  return (
    <Layout>
      <Helmet>
        <title>MALGN | 아카이브 시스템</title>
      </Helmet>
      <div className={classes.wrapper}>
        <div className={classes.slotholder}>
          <div className={classes.caption}>아카이브 시스템</div>
          <div className={classes.captionEng}>Archive System</div>
        </div>
        <div className={classes.section1}>
          <Container maxWidth="md">
            <p>
              하드디스크 기반의 대용량 스토리지의 컨텐츠는 편집 완료 및 방송
              이후에는 아카이브의 목적으로 LTO Tape에 별도 저장합니다.
            </p>
            <p>
              또한 공유 스토리지의 장애를 대비한 백업의 목적으로 LTO
              라이브러리를 사용 하기도 합니다.
            </p>
            <p>
              LTO 미디어는 장기간 안정적으로 데이터를 저장할 수 있으며 소산,
              보관하기 용이한 저장 매체 입니다.
            </p>
          </Container>
        </div>
      </div>
      <div className={classes.section2}>
        <Container maxWidth="md">
          <div style={{ marginBottom: '100px' }}>
            <h1>SPECTRA LOGIC – LTO LIBRARY </h1>
            <div className={classes.hr} />
            <p className={classes.contents}>
              SpectraLogic의 TrsnSacle 구조는 기존에 투자된 자원을 보호하기 위해
              용량/드라이브 증설이 필요한 경우 상위 기종으로 프레임 교체 후
              기존의 부품(드라이브, 전원, 컨트롤러, 테이프)을 그대로 옮겨 사용할
              수 있는 시스템으로 신규 프레임의 도입 및 장애예방에 탁월한
              시스템입니다. 최소 50 슬롯 부터 최대 10,050 슬롯까지 지원하는
              제품군을 보유하고 있으며, 통신, 금융, 방송, 공공 등 다양한
              분야에서 많이 사용되고 있습니다. <br />
            </p>
            <h3>특징</h3>
            <p className={classes.contents}>
              – 업계 최고수준의 확장성 <br />
              – 최대 120 Drive , 10,050개의 미디어 슬롯(T-950 기준) <br />
              – 공간대비 최대의 데이터 저장밀도 <br />
              – 하드웨어 기반의 암호화 기술 <br />
              – 주요부품 hot-swap 지원 <br />
              – 유연한 라이브러리 파티셔닝 <br />
              – 미디어 수명 관리 <br />
              – 단계적 용량 증설 용이 <br />
            </p>
            <h3>제품별비교</h3>
            <img src="/img/digital-media/archive_table.png" />
          </div>
        </Container>
      </div>
      <div className={classes.section2}>
        <Container maxWidth="md">
          <div>
            <h1>ARCHIWARE P5</h1>
            <div className={classes.hr} />
            <Grid container>
              <Grid item xs={12} sm={2}>
                <img src="/img/digital-media/archiware_P5.png" />
              </Grid>
              <Grid item xs={12} sm={10}>
                <p className={classes.contents}>
                  소프트웨어는 널리 알려진 모든 백업 제품군들과 조합이 가능하며
                  Mac, Linux, Windows 그리고 Solaris 를 지원 합니다. 디스크와
                  테입 라이브러리로 저장 가능하고, 저장된 데이터는 여러
                  플랫폼에서 복원하여 사용할 수 있습니다. 특히 Syncronize 기능을
                  이용하면 위치기반 복제(Disk-to-Disk)를 통해 데이터 복원이
                  필요하지 않습니다. 이는 중요한 데이터에 대한 접근 가능성을
                  높이고 업무의 효율을 높이는데 이용됩니다. P5는 브라우저 기반의
                  인터페이스를 제공하여 장소의 제약없이 쉽고 빠르게 관리 및
                  모니터링이 가능하며 모든 데이터에 대한 검색 및 브라우징이
                  가능합니다.
                </p>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} sm={6}>
                <h3>특징</h3>
                <p className={classes.contents}>
                  – 널리 알려진 모든 백업 제품군들과 조합이 가능
                  <br />
                  – 설정 도우미를 통해 수분 내로 설치, 설정 및 실행 가능
                  <br />
                  – 디스크, 테이프, 테이프 라이브러리로 저장 가능 <br />
                  – Mac, Linux, Windows, Solaris 지원
                  <br />– 여러 플랫폼간에 데이터 교환 가능 – 데이터 암호화
                  기능을 제공 <br />
                  – SAN, 파일시스템의 이벤트를 지원(P5 Synchronize 기능) <br />
                  – 모든 기능을 제공하는 30일 트라이얼 버전 무료 제공 <br />
                </p>
              </Grid>
              <Grid item xs={12} sm={6}>
                <img src="/img/digital-media/archive1.png" />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={6}
              style={{
                textAlign: 'center',
              }}
            >
              <Grid item xs={12} sm={3}>
                <a href="http://www.archiware.com/p5-synchronize.301.1.html">
                  <img src="/img/digital-media/archiware_sync.gif" />
                </a>
              </Grid>
              <Grid item xs={12} sm={3}>
                <a href="http://www.archiware.com/p5-backup.302.1.html">
                  <img src="/img/digital-media/archiware_backup.gif" />
                </a>
              </Grid>
              <Grid item xs={12} sm={3}>
                <a href="http://www.archiware.com/p5-backup2go.305.1.html">
                  <img src="/img/digital-media/archiware_back2go.gif" />
                </a>
              </Grid>
              <Grid item xs={12} sm={3}>
                <a href="http://www.archiware.com/p5-archive.303.1.html">
                  <img src="/img/digital-media/archiware_archive.gif" />
                </a>
              </Grid>
            </Grid>
            <div className={classes.downloadArea}>
              <Link
                className={classes.download}
                href="http://www.archiware.com/download-p5.402.1.html"
              >
                시험판 다운로드
              </Link>
              <br />
              <br />
              <Link
                className={classes.download}
                href="https://p5.archiware.com/sites/p5/files/atoms/files/P5_Manual_6.1_EN.pdf"
              >
                사용자 매뉴얼 다운로드
              </Link>
              <br />
              <br />
              <Link
                className={classes.download}
                href="https://p5.archiware.com/masterclass/ "
              >
                동영상 가이드
              </Link>
            </div>
          </div>
        </Container>
      </div>
    </Layout>
  );
}
